import { Grid, MenuItem, TextField } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { getFormItems } from '../../../../../../redux/forms/actions';
import { inputEmptyChecker } from '../../../../../../utils/inputEmptyChecker';
import CustomTextField from '../../../../../layout/customTextField/CustomTextField';
import AddressAutocomplete from '../../../../../addressAutocomplete/AddressAutocomplete';
import styles from './EditModeCorporation.module.scss';

const EditModeCorporation = ({
	formFields,
	formData,
	corporationItems,
	purchaserInformation,
	setPurchaserInformation,
	error,
	setError,
}) => {
	const [data, setData] = useState({});

	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
		console.log('This is the formData', formData);
		setData(corporationItems);

		if (corporationItems) {
			console.log('This is the corporation items', corporationItems);

			setPurchaserInformation(corporationItems);
		}
	}, []);

	useEffect(() => {
		console.log('These are the purchaserInformation', purchaserInformation);
	}, [purchaserInformation]);

	const handleChange = (e, required) => {
		console.log('eeee handleCHnage', required, e.target.value);
		let value = e.target.value;

		if (e.target.name !== 'address2' && inputEmptyChecker(value)) {
			setError({
				...error,
				[e.target.name]: true,
			});
		} else {
			error && delete error[e.target.name];
		}
		if (e.target.name !== 'registrationNumber' || e.target.value >= 0) {
			setPurchaserInformation({
				...purchaserInformation,
				[e.target.name]: e.target.value,
			});
		}
	};

	useEffect(() => {
		console.log('this is the dataaa', data);
	}, [data]);

	return (
		<div className={styles.edit_mode_wrapper}>
			<Grid container>
				<Grid
					container
					item
					xs={11}
					direction='column'
					className={styles.field_container}
					spacing={2}
				>
					<Grid item xs={12} sm={6}>
						{formFields.map((field) => {
							return (
								<div
									key={field?.formName}
									className={styles.textField_item}
								>
									<CustomTextField
										value={
											purchaserInformation[
												field.formName
											] || ''
										}
										formLabel={field.formLabel}
										name={field.formName}
										type={field.formType}
										onChange={(e) => handleChange(e)}
										error={error && error[field?.formName]}
										errorMessage={field?.errorMessage}
									/>
								</div>
							);
						})}
					</Grid>
					<Grid item xs={12} sm={6}>
						<AddressAutocomplete
							formData={purchaserInformation}
							setFormData={setPurchaserInformation}
							defaultData={purchaserInformation}
							onChange={(e) => handleChange(e)}
							error={error}
							setError={setError}
						/>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form?.clientInfo?.corporation.fields,
	formData: state.forms.form?.clientInfo?.corporation.formData,
	corporationItems: state.agreement.agreementById.clientInfo?.corporation,
});

export default connect(mapStateToProps)(EditModeCorporation);
